// extracted by mini-css-extract-plugin
export default {"root":"niS2HH","bg":"Kb4Olh","b":"Cg1Rxk"};